<template>
  <page-outline :title="pageTitle">
    <template slot="pageContent">
      <b-row class="pb-3 no-gutter">
        <back-button returnUrl="/security/-1"></back-button>
      </b-row>
      <b-row class="justify-content-end no-gutter">
        <b-button variant="primary"
          class="mx-3"
          @click="switchMode('view')">
          <span>{{ $t('common.cncl') }}</span>
        </b-button>
        <b-button variant="primary"
          class="mx-3"
          @click="switchMode('edit')">
          <span>{{ $t('administration.edit') }}</span>
        </b-button>
      </b-row>
    </template>
  </page-outline>
</template>
  
<script>

import backButton from "@/components/common/backButton.vue"
import FormAccordion from '@/components/common/FormAccordion.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'

export default {
  name: 'PKCSForm',
  components: {
    'back-button': backButton,
    'form-accordion': FormAccordion,
    'form-read-group-label-input': formReadGroupLabelInput,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline
  },
  props: {
    mode: {
      type: String,
      default: 'add'
    },
    id: {
      type: String,
      default: '-1'
    }
  },
  computed: {
    isEditable () {
      return this.formType === 'add' || this.formType === 'edit'
    }
  },
  data () {
    return {
      certificate: '',
      formType: 'add',
      name: 'certif name',
      pageTitle: ''
    }
  },
  created () {
    this.formType = this.mode
    this.pageTitle = this.$i18n.t('common.security.' + this.mode + '_pkcs')
  },
  methods: {
    switchMode (mode) {
      this.formType = mode
    }
  }
}

</script>